export default {
  start: {
    action: '',
    info: '',
    title: '',
  },
  detail: {
    leaveConfirmation: '',
    leaveTitle: '',
    title: '',
  },
};



// WEBPACK FOOTER //
// ./js/lang/fr/advisory.js